import { render, staticRenderFns } from "./Blueberry_series.vue?vue&type=template&id=c5b968be&scoped=true"
import script from "./Blueberry_series.vue?vue&type=script&lang=js"
export * from "./Blueberry_series.vue?vue&type=script&lang=js"
import style0 from "./Blueberry_series.vue?vue&type=style&index=0&id=c5b968be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b968be",
  null
  
)

export default component.exports